import { render, staticRenderFns } from "./FiltroAdicional.vue?vue&type=template&id=10b01f3c"
import script from "./FiltroAdicional.vue?vue&type=script&lang=js"
export * from "./FiltroAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports